const API_BASE_URL = process.env.REACT_APP_API_URL;

export const getTareasPorEstado = async (estado) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    // Validar que el estado sea 0 o 1
    if (estado !== 0 && estado !== 1) {
      return { success: false, message: 'El estado debe ser 0 o 1.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/estado/${estado}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener las tareas por estado.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener las tareas por estado:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const getTareasPorEstadosEspecificos = async () => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/estados-especificos`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener las tareas por estados específicos.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener las tareas por estados específicos:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const getTareasPorFiltroFecha = async (fechaInicio, fechaFin) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    // Validar que las fechas estén presentes
    if (!fechaInicio || !fechaFin) {
      return { success: false, message: 'Las fechas de inicio y fin son requeridas.' };
    }

    // Validar formato de fecha (YYYY-MM-DD)
    const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!fechaRegex.test(fechaInicio) || !fechaRegex.test(fechaFin)) {
      return { success: false, message: 'El formato de fecha debe ser YYYY-MM-DD.' };
    }

    // Validar que fechaInicio no sea mayor que fechaFin
    if (fechaInicio > fechaFin) {
      return { success: false, message: 'La fecha de inicio no puede ser mayor que la fecha de fin.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/filtro-fecha?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener las tareas por filtro de fecha.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener las tareas por filtro de fecha:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const getEstadisticasDashboard = async () => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}estadisticas-tareas/generales`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener las estadísticas del dashboard.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener las estadísticas del dashboard:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const getResumenGeneralTareas = async (fechaInicio, fechaFin, areaId = null, categoriaId = null, subcategoriaId = null) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    // Validar que las fechas estén presentes
    if (!fechaInicio || !fechaFin) {
      return { success: false, message: 'Las fechas de inicio y fin son requeridas.' };
    }

    // Validar formato de fecha (YYYY-MM-DD)
    const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!fechaRegex.test(fechaInicio) || !fechaRegex.test(fechaFin)) {
      return { success: false, message: 'El formato de fecha debe ser YYYY-MM-DD.' };
    }

    // Validar que fechaInicio no sea mayor que fechaFin
    if (fechaInicio > fechaFin) {
      return { success: false, message: 'La fecha de inicio no puede ser mayor que la fecha de fin.' };
    }

    // Construir la URL con los parámetros
    let url = `${API_BASE_URL}estadisticas-tareas/generales-detalle?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
    
    // Agregar filtros opcionales si están presentes
    if (areaId !== null && areaId !== undefined) {
      url += `&areaId=${areaId}`;
    }
    if (categoriaId !== null && categoriaId !== undefined) {
      url += `&categoriaId=${categoriaId}`;
    }
    if (subcategoriaId !== null && subcategoriaId !== undefined) {
      url += `&subcategoriaId=${subcategoriaId}`;
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener el resumen general de tareas.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener el resumen general de tareas:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const getTareasPorArea = async (fechaInicio, fechaFin, areaId = null, categoriaId = null, subcategoriaId = null) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    // Validar que las fechas estén presentes
    if (!fechaInicio || !fechaFin) {
      return { success: false, message: 'Las fechas de inicio y fin son requeridas.' };
    }

    // Validar formato de fecha (YYYY-MM-DD)
    const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!fechaRegex.test(fechaInicio) || !fechaRegex.test(fechaFin)) {
      return { success: false, message: 'El formato de fecha debe ser YYYY-MM-DD.' };
    }

    // Validar que fechaInicio no sea mayor que fechaFin
    if (fechaInicio > fechaFin) {
      return { success: false, message: 'La fecha de inicio no puede ser mayor que la fecha de fin.' };
    }

    // Construir la URL con los parámetros
    let url = `${API_BASE_URL}estadisticas-tareas/generales?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
    
    // Agregar filtros opcionales si están presentes
    if (areaId !== null && areaId !== undefined) {
      url += `&areaId=${areaId}`;
    }
    if (categoriaId !== null && categoriaId !== undefined) {
      url += `&categoriaId=${categoriaId}`;
    }
    if (subcategoriaId !== null && subcategoriaId !== undefined) {
      url += `&subcategoriaId=${subcategoriaId}`;
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener las estadísticas por área.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener las estadísticas por área:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const getConteoAnidadoTareas = async (fechaInicio, fechaFin, areaId = null, categoriaId = null, subcategoriaId = null) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    // Validar que las fechas estén presentes
    if (!fechaInicio || !fechaFin) {
      return { success: false, message: 'Las fechas de inicio y fin son requeridas.' };
    }

    // Validar formato de fecha (YYYY-MM-DD)
    const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!fechaRegex.test(fechaInicio) || !fechaRegex.test(fechaFin)) {
      return { success: false, message: 'El formato de fecha debe ser YYYY-MM-DD.' };
    }

    // Validar que fechaInicio no sea mayor que fechaFin
    if (fechaInicio > fechaFin) {
      return { success: false, message: 'La fecha de inicio no puede ser mayor que la fecha de fin.' };
    }

    // Construir la URL con los parámetros
    let url = `${API_BASE_URL}estadisticas-tareas/conteo-anidado?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
    
    // Agregar filtros opcionales si están presentes
    if (areaId !== null && areaId !== undefined) {
      url += `&areaId=${areaId}`;
    }
    if (categoriaId !== null && categoriaId !== undefined) {
      url += `&categoriaId=${categoriaId}`;
    }
    if (subcategoriaId !== null && subcategoriaId !== undefined) {
      url += `&subcategoriaId=${subcategoriaId}`;
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener el conteo anidado de tareas.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener el conteo anidado de tareas:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const getHorasPromedioResolucion = async (fechaInicio, fechaFin, areaId = null, categoriaId = null, subcategoriaId = null) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    // Validar que las fechas estén presentes
    if (!fechaInicio || !fechaFin) {
      return { success: false, message: 'Las fechas de inicio y fin son requeridas.' };
    }

    // Validar formato de fecha (YYYY-MM-DD)
    const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!fechaRegex.test(fechaInicio) || !fechaRegex.test(fechaFin)) {
      return { success: false, message: 'El formato de fecha debe ser YYYY-MM-DD.' };
    }

    // Validar que fechaInicio no sea mayor que fechaFin
    if (fechaInicio > fechaFin) {
      return { success: false, message: 'La fecha de inicio no puede ser mayor que la fecha de fin.' };
    }

    // Construir la URL con los parámetros
    let url = `${API_BASE_URL}estadisticas-tareas/promedio-horas-cierre?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
    
    // Agregar filtros opcionales si están presentes
    if (areaId !== null && areaId !== undefined) {
      url += `&areaId=${areaId}`;
    }
    if (categoriaId !== null && categoriaId !== undefined) {
      url += `&categoriaId=${categoriaId}`;
    }
    if (subcategoriaId !== null && subcategoriaId !== undefined) {
      url += `&subcategoriaId=${subcategoriaId}`;
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener las horas promedio de resolución.' };
    }

    const data = await response.json();
    return { success: true, data: { horasPromedio: data } };
  } catch (error) {
    console.error('Error al obtener las horas promedio de resolución:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const getRankingSoporteTecnico = async (fechaInicio, fechaFin, areaId = null) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    // Validar que las fechas estén presentes
    if (!fechaInicio || !fechaFin) {
      return { success: false, message: 'Las fechas de inicio y fin son requeridas.' };
    }

    // Validar formato de fecha (YYYY-MM-DD)
    const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!fechaRegex.test(fechaInicio) || !fechaRegex.test(fechaFin)) {
      return { success: false, message: 'El formato de fecha debe ser YYYY-MM-DD.' };
    }

    // Validar que fechaInicio no sea mayor que fechaFin
    if (fechaInicio > fechaFin) {
      return { success: false, message: 'La fecha de inicio no puede ser mayor que la fecha de fin.' };
    }

    // Construir la URL con los parámetros
    let url = `${API_BASE_URL}estadisticas-tareas/calificaciones?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
    
    // Solo agregar areaId si está presente
    if (areaId !== null && areaId !== undefined) {
      url += `&areaId=${areaId}`;
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener el ranking de soporte técnico.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener el ranking de soporte técnico:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const descargarReporteExcel = async (fechaInicio, fechaFin, areaId = null, categoriaId = null, subcategoriaId = null) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    // Validar que las fechas estén presentes
    if (!fechaInicio || !fechaFin) {
      return { success: false, message: 'Las fechas de inicio y fin son requeridas.' };
    }

    // Validar formato de fecha (YYYY-MM-DD)
    const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!fechaRegex.test(fechaInicio) || !fechaRegex.test(fechaFin)) {
      return { success: false, message: 'El formato de fecha debe ser YYYY-MM-DD.' };
    }

    // Validar que fechaInicio no sea mayor que fechaFin
    if (fechaInicio > fechaFin) {
      return { success: false, message: 'La fecha de inicio no puede ser mayor que la fecha de fin.' };
    }

    // Construir URL con parámetros de filtros
    let url = `${API_BASE_URL}estadisticas-tareas/reporte-excel?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
    
    if (areaId !== null) {
      url += `&areaId=${areaId}`;
    }
    if (categoriaId !== null) {
      url += `&categoriaId=${categoriaId}`;
    }
    if (subcategoriaId !== null) {
      url += `&subcategoriaId=${subcategoriaId}`;
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al descargar el reporte Excel.' };
    }

    // Obtener el blob del archivo
    const blob = await response.blob();
    
    // Crear URL para descarga
    const downloadUrl = window.URL.createObjectURL(blob);
    
    // Crear nombre de archivo con información de filtros
    let fileName = `reporte-tareas-${fechaInicio}-${fechaFin}`;
    if (areaId !== null) {
      fileName += `-area${areaId}`;
    }
    if (categoriaId !== null) {
      fileName += `-cat${categoriaId}`;
    }
    if (subcategoriaId !== null) {
      fileName += `-sub${subcategoriaId}`;
    }
    fileName += '.xlsx';
    
    // Crear elemento de descarga
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    
    // Limpiar
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);

    return { success: true, message: 'Reporte descargado exitosamente.' };
  } catch (error) {
    console.error('Error al descargar el reporte Excel:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const descargarReporteTareasCerradas = async (fechaInicio, fechaFin, areaId = null, categoriaId = null, subcategoriaId = null) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    // Validar que las fechas estén presentes
    if (!fechaInicio || !fechaFin) {
      return { success: false, message: 'Las fechas de inicio y fin son requeridas.' };
    }

    // Validar formato de fecha (YYYY-MM-DD)
    const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!fechaRegex.test(fechaInicio) || !fechaRegex.test(fechaFin)) {
      return { success: false, message: 'El formato de fecha debe ser YYYY-MM-DD.' };
    }

    // Validar que fechaInicio no sea mayor que fechaFin
    if (fechaInicio > fechaFin) {
      return { success: false, message: 'La fecha de inicio no puede ser mayor que la fecha de fin.' };
    }

    // Construir URL con parámetros de filtros
    let url = `${API_BASE_URL}tareas/reporte-tareas-cerradas?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
    
    if (areaId !== null) {
      url += `&areaId=${areaId}`;
    }
    if (categoriaId !== null) {
      url += `&categoriaId=${categoriaId}`;
    }
    if (subcategoriaId !== null) {
      url += `&subcategoriaId=${subcategoriaId}`;
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al descargar el reporte de tareas cerradas.' };
    }

    // Obtener el blob del archivo
    const blob = await response.blob();
    
    // Crear URL para descarga
    const downloadUrl = window.URL.createObjectURL(blob);
    
    // Crear nombre de archivo con información de filtros
    let fileName = `reporte-tareas-cerradas-${fechaInicio}-${fechaFin}`;
    if (areaId !== null) {
      fileName += `-area${areaId}`;
    }
    if (categoriaId !== null) {
      fileName += `-cat${categoriaId}`;
    }
    if (subcategoriaId !== null) {
      fileName += `-sub${subcategoriaId}`;
    }
    fileName += '.xlsx';
    
    // Crear elemento de descarga
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    
    // Limpiar
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);

    return { success: true, message: 'Reporte de tareas cerradas descargado exitosamente.' };
  } catch (error) {
    console.error('Error al descargar el reporte de tareas cerradas:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

// Nuevo: Descargar Excel con todas las tareas (respeta filtros)
export const descargarReporteTodasTareas = async (fechaInicio, fechaFin, areaId = null, categoriaId = null, subcategoriaId = null) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    if (!fechaInicio || !fechaFin) {
      return { success: false, message: 'Las fechas de inicio y fin son requeridas.' };
    }

    const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!fechaRegex.test(fechaInicio) || !fechaRegex.test(fechaFin)) {
      return { success: false, message: 'El formato de fecha debe ser YYYY-MM-DD.' };
    }

    if (fechaInicio > fechaFin) {
      return { success: false, message: 'La fecha de inicio no puede ser mayor que la fecha de fin.' };
    }

    let url = `${API_BASE_URL}tareas/reporte-todas-tareas?FechaInicio=${fechaInicio}&FechaFin=${fechaFin}`;
    if (areaId !== null) url += `&AreaId=${areaId}`;
    if (categoriaId !== null) url += `&CategoriaId=${categoriaId}`;
    if (subcategoriaId !== null) url += `&SubcategoriaId=${subcategoriaId}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${token}` },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al descargar el reporte de todas las tareas.' };
    }

    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);

    let fileName = `todas-las-tareas-${fechaInicio}-${fechaFin}`;
    if (areaId !== null) fileName += `-area${areaId}`;
    if (categoriaId !== null) fileName += `-cat${categoriaId}`;
    if (subcategoriaId !== null) fileName += `-sub${subcategoriaId}`;
    fileName += '.xlsx';

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);

    return { success: true };
  } catch (error) {
    console.error('Error al descargar el reporte de todas las tareas:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

// Nueva función para obtener diagnóstico sin filtro
export const getDiagnosticoSinFiltro = async () => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}estadisticas-tareas/diagnostico-sin-filtro`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener el diagnóstico sin filtro.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener el diagnóstico sin filtro:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

// Nueva función para obtener tareas detalle
export const getTareasDetalle = async (fechaInicio, fechaFin, areaId = null, categoriaId = null, subcategoriaId = null) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    // Validar que las fechas estén presentes
    if (!fechaInicio || !fechaFin) {
      return { success: false, message: 'Las fechas de inicio y fin son requeridas.' };
    }

    // Validar formato de fecha (YYYY-MM-DD)
    const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!fechaRegex.test(fechaInicio) || !fechaRegex.test(fechaFin)) {
      return { success: false, message: 'El formato de fecha debe ser YYYY-MM-DD.' };
    }

    // Validar que fechaInicio no sea mayor que fechaFin
    if (fechaInicio > fechaFin) {
      return { success: false, message: 'La fecha de inicio no puede ser mayor que la fecha de fin.' };
    }

    // Construir la URL con los parámetros
    let url = `${API_BASE_URL}estadisticas-tareas/tareas-detalle?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
    
    // Agregar filtros opcionales si están presentes
    if (areaId !== null && areaId !== undefined) {
      url += `&areaId=${areaId}`;
    }
    if (categoriaId !== null && categoriaId !== undefined) {
      url += `&categoriaId=${categoriaId}`;
    }
    if (subcategoriaId !== null && subcategoriaId !== undefined) {
      url += `&subcategoriaId=${subcategoriaId}`;
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener el detalle de tareas.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener el detalle de tareas:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};
